export default {
  snippets: [],
  tags: [],
  canvas: {
    width: 1920,
    height: 1080,
  },
  safeArea: {
    show: false,
    width: 90,
    height: 90,
  },
  guides: {
    show: false,
    hGuides: [],
    vGuides: [],
  },
};
